<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
            ></head-menu-filter>

            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.nummer"
                        class="form-control input"
                        type="number"
                        placeholder=" "
                        min="0"
                      />
                      <label>{{ $t("global.number") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.vermittlungsstelle"
                        label="bezeichnung"
                        :options="vermittlungsstellen"
                        :placeholder="$t('global.switchboard')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.switchboard") }}</label>
                    </div>
                    <!-- <single-select-firma
                      id="angebot-vs"
                      :firma="filters.vermittlungsstelle"
                      :editable="true"
                      :allowOpen="true"
                      :label="$t('global.switchboard')"
                      @confirmed="setVS"
                    /> -->
                    <!-- <div class="form-group">
                      <input
                        v-model="filters.vs"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>Vermittlungsstelle</label>
                    </div> -->
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.fromstart") }}</label>
                      <input
                        v-model="filters.vonStart"
                        type="date"
                        class="form-control"
                        :max="maxVonStart"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.fromend") }}</label>
                      <input
                        v-model="filters.vonEnde"
                        type="date"
                        class="form-control"
                        :min="filters.vonStart"
                        :max="filters.bisEnde"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.untilstart") }}</label>
                      <input
                        v-model="filters.bisStart"
                        type="date"
                        class="form-control"
                        :max="filters.bisEnde"
                        :min="filters.vonStart"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.untilend") }}</label>
                      <input
                        v-model="filters.bisEnde"
                        type="date"
                        class="form-control"
                        :min="minBisEnde"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.angebotstatus"
                        label="bezeichnung"
                        :options="angebotstati"
                        :placeholder="$t('global.offerstatus')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.offerstatus") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-firma
                      id="angebot-hof"
                      :firma="filters.hof"
                      :editable="true"
                      :allowOpen="true"
                      :label="$t('global.farm')"
                      @confirmed="setHof"
                    />
                  </div>
                  <!-- <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.hof"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>Hof</label>
                    </div>
                  </div> -->
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.auswahlEinsatzbereich"
                        label="bezeichnung"
                        :options="einsatzbereiche"
                        :placeholder="$t('global.areasofapplication')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.areasofapplication") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.sprache"
                        label="bezeichnung"
                        :options="sprachen"
                        :placeholder="$t('global.language')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.language") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12 my-2">
                    <div style="margin-left: 7px">
                      <label
                        class="float-left"
                        style="
                          font-size: 11px !important;
                          font-weight: 700 !important;
                        "
                        >{{ $t("global.actualtimeoperation") }}</label
                      ><input
                        class="form-check-input mx-3"
                        style="margin-top: 0.2rem"
                        v-model="filters.istZeitbetrieb"
                        type="checkbox"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.count"
                        class="form-control"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t("global.numberofrecords") }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.offers')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                    <button
                      class="btn btn-success"
                      @click="neuesAngebot"
                      v-if="berechtigungen.m_notizen.create"
                    >
                      <font-awesome-icon
                        icon="fa-regular fa-plus"
                        class="mr-2"
                      />{{ $t("global.new") }}
                    </button>
                    <excel-export-modal
                      class="d-inline-block ml-2"
                      :filters="queryParams"
                      :config="excelExportConfig"
                    />
                  </div>
                  <div class="mr-4 float-right">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="berechtigungen.m_notizen.delete"
                      :disabled="selectedIds.length === 0"
                      :title="
                        selectedIds.length === 0
                          ? $t('global.selectminone')
                          : ''
                      "
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />{{ $t("global.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    no-local-sorting
                    @sort-changed="onSortChanged"
                    sort-icon-left
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template slot="top-row" slot-scope="{ fields }">
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' && field.searchable != false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                        />
                      </td>
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(einsatzbereiche)="row">
                      {{
                        row.item.einsatzbereiche
                          .map((e) => e.bezeichnung)
                          .join(", ")
                      }}
                    </template>

                    <template v-slot:cell(ist_zeitbetrieb)="row">
                      {{ row.item.ist_zeitbetrieb ? "✓" : "" }}
                    </template>
                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(state) => infiniteHandler(state, 'app-api')"
                  >
                    <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                    <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                    <div slot="no-results">
                      {{ $t("global.nofurtherdatafound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="angebot-loeschen-modal"
      :selectedIds="this.selectedIds"
      :multiple="true"
      @confirmed="angebotLoeschen"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import HeadMenu from "@/components/HeadMenu";
import HeadMenuFilter from "@/components/HeadMenuFilter";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";
import ExcelExportModal from "@/components/Modals/ExcelExportModal.vue";

import store from "@/store";
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/FilterNew";

import {LADE_AUSWAHLWERTE_CRM} from "@/store/crm/actions.type";
import {apiErrorToAlert} from "@/utils/Errorhandler";

export default {
  name: "Angebote",
  components: {
    Navbar,
    HeadMenu,
    HeadMenuFilter,
    LoeschenModal,
    FilterSearchResetButton,
    SingleSelectFirma,
    ExcelExportModal,
  },
  metaInfo() {
    return {
      titleTemplate: () => {
        return "BX: " + this.$t("global.offers");
      },
    };
  },
  mixins: [page, dashboard, filter],
  props: {},
  store,
  data() {
    return {
      filterMitarbeitende: this.$CONST("ROLLEN").MITARBEITER,
      angebote: [
        {
          id: "23232323",
          nummer: 11111,
          beschreibung: "test",
          firma: { id: "196805F14D7", name: "test" },
          auswahl_einsatzbereich: "234234",
          von: "02.05.2025",
          bis: "06.08.2025",
          belastungsgrad: 4,
          zeitbetriebsangaben: "23123",
          vermittlungsstelle: "23423",
          angebotstatus: "234223",
        },
        {
          id: "23232323",
          nummer: 11111,
          beschreibung: "test",
          firma: { id: "196805F14D7", name: "test" },
          auswahl_einsatzbereich: "234234",
          von: "02.05.2025",
          bis: "06.08.2025",
          belastungsgrad: 4,
          zeitbetriebsangaben: "23123",
          vermittlungsstelle: "23423",
          angebotstatus: "234223",
        },
      ],
      sortBy: null,
      sortDesc: false,
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        {
          key: "nummer",
          sortable: true,
          label: this.$t("global.number"),
        },
        {
          key: "von",
          sortable: true,
          searchable: false,
          label: this.$t("global.From"),
        },
        {
          key: "bis",
          sortable: true,
          searchable: false,
          label: this.$t("global.till"),
        },
        {
          key: "angebotstatus.bezeichnung",
          sortable: true,
          searchable: false,
          label: this.$t("global.offerstatus"),
        },
        {
          key: "firma.name",
          sortable: true,
          searchable: false,
          label: this.$t("global.farm"),
        },
        {
          key: "ist_zeitbetrieb",
          sortable: true,
          searchable: false,
          label: this.$t("global.actualtimeoperation"),
        },
        {
          key: "vermittlungsstelle.bezeichnung",
          sortable: true,
          searchable: false,
          label: this.$t("global.switchboard"),
        },
        {
          key: "einsatzbereiche",
          sortable: true,
          searchable: false,
          label: this.$t("global.areasofapplication"),
        },
      ];
    },
    queryParams: function () {
      var params = {};

      const vonStart = this.isoToGerman(this.filters.vonStart);
      const vonEnde = this.isoToGerman(this.filters.vonEnde);
      const bisStart = this.isoToGerman(this.filters.bisStart);
      const bisEnde = this.isoToGerman(this.filters.bisEnde);

      params.filterNummer = this.setQueryParam(this.filters.nummer);
      params.filterFirma = this.setQueryParam(this.filters.hof?.id);
      params.filterAngebotstatus = this.setQueryParam(
        this.filters.angebotstatus?.join(",")
      );
      params.filterVonStart = this.setQueryParam(vonStart);
      params.filterVonEnde = this.setQueryParam(vonEnde);
      params.filterBisStart = this.setQueryParam(bisStart);
      params.filterBisEnde = this.setQueryParam(bisEnde);
      params.filterVermittlungsstelle = this.setQueryParam(
        this.filters.vermittlungsstelle?.join(",")
      );
      params.filterZeitbetrieb = this.setQueryParam(
        this.filters.istZeitbetrieb
      );
      params.filterEinsatzbereich = this.setQueryParam(
        this.filters.auswahlEinsatzbereich?.join(",")
      );

      params.count = this.setQueryParam(
        this.filters.count ? this.filters.count : 50
      );
      params.filterSprache = this.setQueryParamList(this.filters.sprache);

      // TODO

      //params.datum = this.setQueryParam(this.filters.datum)
      //params.filterKPerson = this.setQueryParam(this.filters.kontaktpersonen)
      //params.filterKABez = this.setQueryParam(this.filters['kontaktart.bezeichnung'])
      //params.filterKDurch = this.setQueryParam(this.filters['kontakt_durch.personName'])

      params.sortBy = this.sortBy || undefined;
      params.sortDesc = this.sortBy ? this.sortDesc : undefined;

      return params;
    },
    excelExportConfig() {
      return {
        endpoint: "angebotliste",
        filename: "Angebotliste",
        stichtag: true,
        stichtagHint: "optional – nur Einsatzplätze, die am gewählten Datum angeboten werden",
        baseColumns: [
          { key: "nr",                 label: this.$t("global.number") },
          { key: "von",                label: this.$t("global.From") },
          { key: "bis",                label: this.$t("global.till") },
          { key: "status",             label: this.$t("global.offerstatus") },
          { key: "betrieb",            label: "Betrieb" },
          { key: "istAlpeinsatz",      label: this.$t("global.actualtimeoperation") },
          { key: "vermittlungsstelle", label: this.$t("global.switchboard") },
        ],
        additionalFields: [
          { key: "plz",                label: this.$t("global.zipcode") },
          { key: "ort",                label: this.$t("global.city") },
          { key: "kanton",             label: this.$t("global.canton") },
          { key: "einsatzbereiche",    label: this.$t("global.areasofapplication") + " (je Wert eine Spalte)" },
          { key: "sprache",            label: this.$t("global.language") },
        ],
        summaryFields: [
          { key: "per_status",          label: "Angebote pro Status" },
          { key: "per_kanton",          label: "Angebote pro Kanton" },
          { key: "per_vs",              label: "Angebote pro VS" },
          { key: "per_betrieb",         label: "Angebote pro Betrieb" },
          { key: "per_aufgabenbereich", label: "Angebote pro Aufgabenbereich" },
          { key: "per_alpeinsatz",      label: "Alpeinsätze" },
        ],
      };
    },

    angebotstati() {
      if (this.$store) return this.$store.state.crm.angebotstati;
      return [];
    },
    einsatzbereiche() {
      if (this.$store) return this.$store.state.crm.einsatzbereiche;
      return [];
    },
    sprachen: {
      get() {
        return this.$store.state.crm.sprachen;
      },
    },
    vermittlungsstellen() {
      if (this.$store) return this.$store.state.crm.vermittlungsstellen;
      return [];
    },
    maxVonStart() {
      const { vonEnde, bisEnde } = this.filters;

      if (!vonEnde) return bisEnde || null;
      if (!bisEnde) return vonEnde;

      return new Date(vonEnde) < new Date(bisEnde) ? vonEnde : bisEnde;
    },
    minBisEnde() {
      const { vonStart, bisStart } = this.filters;

      if (!vonStart) return bisStart || null;
      if (!bisStart) return vonStart;

      return new Date(vonStart) > new Date(bisStart) ? vonStart : bisStart;
    },
  },
  created() {
    this.initFilter("angebotliste", "angebotliste/", false);
  },
  mounted() {
    this.$bus.$emit("searchWithFilter");

    if (this.angebotstati?.length == 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);
  },
  methods: {
    isoToGerman(dateString) {
      if (!dateString) {
        return null;
      }
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },

    details(angebot) {
      this.$router.push({
        name: "Angebot",
        params: { id: angebot.id, anzeige: 0 },
      });
    },

    setVS(vs) {
      this.$set(this.filters, "vermittlungsstelle", vs);
    },

    setHof(hof) {
      this.$set(this.filters, "hof", hof);
    },

    angebotLoeschen() {
      if (this.loading) return;
      this.loading = true;

      AppApi.delete("angebotmaske", {
        data: this.selectedIds,
      })
        .then(() => {
          this.resetLoading(this);
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.successfullydeleted"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "angebot-loeschen-modal");
    },

    neuesAngebot() {
      this.$router.push({
        name: "Angebot",
        params: {
          anzeige: "0",
        },
      });
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((item) => {
          item.selected = true;
        });
      } else {
        this.$refs.selectableTable.items.forEach((item) => {
          item.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
      }
    },

    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.filterValues = this.queryParams;
      this.resetLoading(this);
    }
  },
};
</script>
